module.exports = __webpack_public_path__ + "img/Assistance_red.be9f7638.svg";